<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <!-- Welcome Card -->
          <v-card class="card--shadow welcome-card" elevation="0">
            <v-card-text class="pa-8">
              <div class="welcome-content">
                <div class="welcome-header">
                  <v-icon class="welcome-icon" color="#aa00ff" size="64">
                    mdi-account-circle
                  </v-icon>
                  <div class="welcome-text">
                    <h1 class="welcome-title">
                      Welcome back, Admin Dashboard
                    </h1>
                    <p class="welcome-subtitle">
                      CBDRTBC Dashboard
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <!-- Quick Stats Cards -->
        <v-col cols="12" md="4">
          <v-card 
            class="card--shadow stat-card clickable-card" 
            elevation="0"
            @click="goToPatients"
          >
            <v-card-text class="pa-6">
              <div class="stat-content">
                <v-icon class="stat-icon" color="#aa00ff" size="48">
                  mdi-account-group
                </v-icon>
                  <div class="stat-details">
                  <h3 class="stat-label">Patients</h3>
                  <div class="stat-count">
                    <span class="count-number">{{ totalPatients || 0 }}</span>
                    <span class="count-label">Total Patients</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card 
            class="card--shadow stat-card clickable-card" 
            elevation="0"
            @click="goToVolunteers"
          >
            <v-card-text class="pa-6">
              <div class="stat-content">
                <v-icon class="stat-icon" color="#ff6f00" size="48">
                  mdi-account-multiple
                </v-icon>
                <div class="stat-details">
                  <h3 class="stat-label">Volunteers</h3>
                  <div class="stat-count">
                    <span class="count-number">{{ totalVolunteers || 0 }}</span>
                    <span class="count-label">Total Volunteers</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="card--shadow stat-card" elevation="0">
            <v-card-text class="pa-6">
              <div class="stat-content">
                <v-icon class="stat-icon" color="#00bfa5" size="48">
                  mdi-chart-line
                </v-icon>
                <div class="stat-details">
                  <h3 class="stat-label">Reports</h3>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},
  computed: {
    ...mapState("Admin", ["admin"]),
    ...mapState("Patient", ["patients", "pageCount", "totalPatients"]),
    ...mapState("Volunteer", ["volunteers", "totalVolunteers"]),
  },
  data: () => ({
    patientCount: 0,
  }),
  created() {
    this.fetchPatientCount();
    this.fetchVolunteerCount();
  },
  methods: {
    goToPatients() {
      this.$router.push("/patient");
    },
    goToVolunteers() {
      this.$router.push("/volunteer");
    },
    async fetchPatientCount() {
      // Fetch first page to get pageCount which helps estimate total
      try {
        await this.$store.dispatch("Patient/getPatients", { page: 1 });
      } catch (error) {
        console.error("Error fetching patient count:", error);
      }
    },
    async fetchVolunteerCount() {
      // Fetch volunteers to get total count
      try {
        await this.$store.dispatch("Volunteer/getVolunteers");
      } catch (error) {
        console.error("Error fetching volunteer count:", error);
      }
    },
  },
};
</script>

<style scoped>
.welcome-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-left: 4px solid #aa00ff;
  border-radius: 12px;
}

.welcome-content {
  display: flex;
  align-items: center;
}

.welcome-header {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.welcome-icon {
  flex-shrink: 0;
}

.welcome-text {
  flex: 1;
}

.welcome-title {
  font-size: 32px;
  font-weight: 600;
  color: #424242;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.welcome-subtitle {
  font-size: 16px;
  color: #757575;
  margin: 0;
  font-weight: 400;
}

.stat-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  height: 100%;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(170, 0, 255, 0.15) !important;
}

.clickable-card {
  cursor: pointer;
}

.clickable-card:hover {
  background-color: #f8f9ff !important;
}

.stat-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-icon {
  flex-shrink: 0;
}

.stat-details {
  flex: 1;
}

.stat-label {
  font-size: 20px;
  font-weight: 600;
  color: #424242;
  margin: 0 0 8px 0;
}

.stat-description {
  font-size: 14px;
  color: #757575;
  margin: 0;
}

.stat-count {
  margin: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.count-number {
  font-size: 32px;
  font-weight: 700;
  color: #aa00ff;
  line-height: 1;
}

.count-label {
  font-size: 12px;
  color: #757575;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-card {
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
}

.info-card-title {
  font-size: 20px;
  font-weight: 600;
  color: #424242;
  padding: 20px 24px 16px 24px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}

.info-item {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-icon {
  flex-shrink: 0;
  margin-top: 4px;
}

.info-item-title {
  font-size: 16px;
  font-weight: 600;
  color: #424242;
  margin: 0 0 4px 0;
}

.info-item-text {
  font-size: 14px;
  color: #757575;
  margin: 0;
  line-height: 1.5;
}

/* Responsive Design */
@media (max-width: 960px) {
  .welcome-title {
    font-size: 24px;
  }

  .welcome-subtitle {
    font-size: 14px;
  }

  .welcome-header {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .stat-content {
    flex-direction: column;
    text-align: center;
  }

  .info-item {
    flex-direction: column;
    text-align: center;
  }
}
</style>
